// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"9f714a24","990":"870d3eb8"}[chunkId] + ".chunk.js";
};